module.exports = __webpack_public_path__ + "img/04-min.aa77ce94.jpg";